import { createAction } from 'redux-actions'

const ENTITY = 'TABLE'
export const stateKey = ENTITY.toLowerCase()

export const setCheckedTableRows = createAction(`${ENTITY}/CHECKED_ROWS`, (payload) => payload)
export const resetTableCheckbox = createAction(`${ENTITY}/RESET_CHECKBOX`, (payload) => payload)